import { forwardRef, SyntheticEvent } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { UserSelection, UserSelectionProps } from "../user-selection/UserSelection";
import { Collaborator } from "../user-selection/collaborator";
import { Container, StyledFormLabel, StyledFormHelperText } from "./CommonStyles";

interface UserSelectionFieldProps extends UserSelectionProps {
    id: string;
    defaultValue?: Collaborator[];
    label?: string;
    description?: string;
    inline?: boolean;
}

/**
 * user selection field
 */
export const UserSelectionField = forwardRef<any, UserSelectionFieldProps>((props: UserSelectionFieldProps, ref) => {
    const { id, label, description, defaultValue, inline, ...rest } = props;

    const { control } = useFormContext();

    return (
        <Container inline={inline}>
            {label && <StyledFormLabel htmlFor={id} text={label} fontWeightBold={true} />}
            {description && <StyledFormHelperText>{description}</StyledFormHelperText>}

            <Controller
                control={control}
                name={id}
                defaultValue={defaultValue || []}
                render={({ field: { onChange, onBlur, value } }) => (
                    <UserSelection
                        {...rest}
                        id={id}
                        value={value}
                        ref={ref}
                        onChange={(event: SyntheticEvent<Element, Event>, value: Collaborator[]) => {
                            onChange(value);
                        }}
                        onBlur={onBlur}
                    />
                )}
            />
        </Container>
    );
});
